<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Make an Inventory Adjustment</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Product Being Adjusted</label>
            <span>{{ product.name }}</span>
          </div>

          <div class="columns" v-if="storageUnit">
            <div class="column is-one-third">
              <label class="label">Warehouse</label>
              <span>{{ storageUnit.storage.warehouse_location.warehouse.warehouse_name }}</span>
            </div>
            <div class="column is-one-third">
              <label class="label">Warehouse Location</label>
              <span>{{ storageUnit.storage.warehouse_location.location_name }}</span>
            </div>
            <div class="column is-one-third">
              <label class="label">Storage</label>
              <span>
                {{ storageUnit.storage.storage_type.storage_type_name }} 
                ({{ storageUnit.storage.storage_code }}) 
                {{ storageUnit.storage.storage_name }}
              </span>
            </div>
          </div>

          <div class="columns">
            <div class="column is-half" v-if="storageUnit">
              <label class="label">Current Quantity Available</label>
              <span>{{ parseInt(qtyAvailable) + parseInt(difference) }}</span>
            </div>

            <div class="column is-half">
              <label class="label">Adjustment*</label>
              <v-text-field
                required
                placeholder="Enter quantity adjustment"
                type="number"
                v-model="difference">
              </v-text-field>
            </div>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="adjust()">
            Adjust Inventory
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'

import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    productInventory: {
      type: Object
    },
    storageUnit: {
      type: Object
    }
  },
  components: { 
    VForm,
    VTextField,
  },
  data() {
    return {
      difference: 0,
      valid: false
    }
  },
  computed: {
    product() {
      return this.productInventory.product_master;
    },
    qtyAvailable() {
      return this.storageUnit.qty;
    }
  },
  methods: {
    ...mapActions("inventoryCentral", ["adjustInventory"]),
    adjust() {
      this.adjustInventory({
        stocking_unit_id: this.productInventory.stocking_unit_id,
        storage_unit_id: this.storageUnit.id,
        difference: this.difference
      }).then(() => this.close(true))
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
